<template>
<div>
  <!-- گیرنده -->
  <v-row>
    <v-col cols="12" sm="4" dir="rtl"></v-col>
    <v-col cols="12" sm="5" dir="rtl">
      <h1 class="text-rtl">{{ receiverTitle }}</h1>
    </v-col>
    <v-col cols="12" sm="3" dir="rtl">
      <h2 class="text-ltr">گیرنده :</h2>
    </v-col>
  </v-row>

  <!-- آدرس -->
  <v-row>
    <v-col cols="12" sm="4" dir="rtl"></v-col>
    <v-col cols="12" sm="5" dir="rtl">
      <h1 class="text-rtl">{{ data.address }}</h1>
    </v-col>
    <v-col cols="12" sm="3" dir="rtl">
      <h2 v-if="data.address" class="text-ltr">آدرس :</h2>
    </v-col>
  </v-row>

  <!-- کد پستی -->
  <v-row>
    <v-col cols="12" sm="4" dir="rtl"></v-col>
    <v-col cols="12" sm="5" dir="rtl">
      <h1 class="text-rtl">{{ data.zip_code }}</h1>
    </v-col>
    <v-col cols="12" sm="3" dir="rtl">
      <h2 v-if="data.zip_code" class="text-ltr">کد پستی :</h2>
    </v-col>
  </v-row>

  <!-- خط جداکننده -->
  <v-row>
    <v-col cols="12" sm="5" dir="rtl"></v-col>
    <v-col cols="12" sm="5" dir="rtl">
      <h1 class="text-rtl">--------------------</h1>
    </v-col>
    <v-col cols="12" sm="6" dir="rtl"></v-col>
  </v-row>

  <!-- فرستنده -->
  <v-row>
    <v-col cols="12" sm="4" dir="rtl"></v-col>
    <v-col cols="12" sm="5" dir="rtl">
      <h1 class="text-rtl">{{ sender }}</h1>
    </v-col>
    <v-col cols="12" sm="3" dir="rtl">
      <h2 class="text-ltr">فرستنده :</h2>
    </v-col>
  </v-row>

  <!-- آدرس فرستنده -->
  <v-row>
    <v-col cols="12" sm="4" dir="rtl"></v-col>
    <v-col cols="12" sm="5" dir="rtl">
      <h1 class="text-rtl">{{ senderAddress }}</h1>
    </v-col>
    <v-col cols="12" sm="3" dir="rtl"></v-col>
  </v-row>

  <!-- بیمه و کد ملی -->
  <v-row class="mb-n-12">
    <v-col cols="12" sm="4" dir="rtl">
      <h1 class="vericaltext">بیمه :</h1>
    </v-col>
    <v-col cols="12" sm="5" dir="rtl">
      <h1 class="text-rtl">{{ nationalId }}</h1>
    </v-col>
    <v-col cols="12" sm="3" dir="rtl">
      <h2 class="text-ltr">کد ملی :</h2>
    </v-col>
  </v-row>
</div>
</template>

<script>
export default {
  name: "PrintTipax",
  props: {
    data: {
      type: Object,
      required: true
    },
    sender: {
      type: String,
      default: "قاسمی (۰۹۳۶۶۸۷۷۷۹۸)"
    },
    senderAddress: {
      type: String,
      default: "مشهد بازار رضا پلاک ۲/۶۰۵"
    },
    nationalId: {
      type: String,
      default: "۰۹۳۶۹۴۱۳۶۷"
    }
  },
  computed: {
    receiverTitle() {
      const {
        gender,
        type,
        name,
        mobile
      } = this.data
      let title = name
      if (mobile) title += ` (${mobile})`
      if (gender) return `آقای ${title}`
      if (!gender && type === 'person') return `خانم ${title}`
      return title
    }
  }
}
</script>

<style scoped>
.text-rtl {
  text-align: right;
  font-family: titr;
}

.text-ltr {
  text-align: left;
  font-family: titr;
}

.vericaltext {
  text-align: right;
  font-family: titr;
  writing-mode: vertical-lr;
  text-orientation: mixed;
}

h1,
h2 {
  font-family: titr;
}
</style>
